var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "box-card",
          attrs: { shadow: "never" },
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v("结算账户"),
          ]),
          _c(
            "el-row",
            { staticClass: "stat-row", attrs: { gutter: 16 } },
            _vm._l(_vm.balanceCards, function (item) {
              return _c("el-col", { key: item.key, attrs: { span: 6 } }, [
                _c("div", { staticClass: "stat" }, [
                  _c("div", { staticClass: "stat-label" }, [
                    _vm._v(_vm._s(item.label)),
                  ]),
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.yuan(_vm.account[item.key]))),
                  ]),
                  _c("div", { staticClass: "stat-desc" }, [
                    _vm._v(_vm._s(item.desc)),
                  ]),
                ]),
              ])
            }),
            1
          ),
          _c(
            "el-form",
            {
              staticClass: "rule-form",
              attrs: { "label-width": "140px", size: "small" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "平台服务费率：" } },
                        [
                          _vm._v(
                            _vm._s(_vm.percent(_vm.account.serviceFeeRatio))
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "最高抵扣占比：" } },
                        [
                          _vm._v(
                            _vm._s(_vm.percent(_vm.account.maxDeductRatio))
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "单笔抵扣积分上限：" } },
                        [
                          _vm._v(
                            _vm._s(_vm.limitText(_vm.account.singleLimitPoints))
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "每日抵扣积分上限：" } },
                        [
                          _vm._v(
                            _vm._s(_vm.limitText(_vm.account.dailyLimitPoints))
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "tips" }, [
            _vm._v(
              " 抵扣规则由平台设定，商户端只读。应收 = 抵扣折算金额 − 平台服务费。 "
            ),
          ]),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card mt16", attrs: { shadow: "never" } },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v(" 资金流水 "),
            _c("span", { staticClass: "sub" }, [
              _vm._v("准复式记账，每一笔都能追到对应的核销单号"),
            ]),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.ledgerLoading,
                  expression: "ledgerLoading",
                },
              ],
              attrs: { data: _vm.ledger, size: "small", border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "transactionId",
                  label: "事务号",
                  "min-width": "170",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "方向", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: row.direction === 1 ? "success" : "danger",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(row.direction === 1 ? "增加" : "减少") +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "金额", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.yuan(row.amount)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "余额科目", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.fieldText(row.balanceField)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "变动前", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.yuan(row.beforeBalance)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "变动后", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.yuan(row.afterBalance)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "sourceType", label: "来源", width: "130" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "bizNo",
                  label: "业务单号",
                  "min-width": "170",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "reversalNo",
                  label: "冲正号",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "时间",
                  "min-width": "150",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.$constants.page.limit,
                  "page-size": _vm.page.size,
                  "current-page": _vm.page.page,
                  layout: "prev, pager, next, sizes",
                },
                on: {
                  "size-change": _vm.onSizeChange,
                  "current-change": _vm.onPageChange,
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "tips" }, [
            _vm._v(
              " 流水接口只返回当前页数据、不返回总数，所以这里没有总条数；翻到空页说明已经到底了。 "
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }